/**
 * Email transcript
 */
export class EmailTranscriptPlugin {
	/**
	 * Chat core object
	 */
	chat;

	constructor(chat){
		this.chat = chat;
	}

	init() {
		const picker = jQuery(BTN_TEMPLATE);

		this.chat.$el.find('.attachment-wrapper .attachment-list').append(picker);

		picker.click(() => this.show_picker());

        this.chat.$el.on('submit', '#wschat_email_transcript_form', e => this.submit_form(e))
        this.chat.$el.on('click', '#wschat_email_transcript_form_close', e => this.remove_form(e))
	}

    submit_form(e) {
        e.preventDefault();
        const data = {
            email: jQuery('#email_transcript_field_email').val(),
            action: this.ACTION_EMAIL_TRANSCRIPT,
            conversation_id: this.chat.conversation.id
        };

        const frm = jQuery(e.target);

        const btn  = frm.find('button[type=submit]');
        btn.prop('disabled', true);

        jQuery.post(this.chat.options.api.endpoint, data, (res) => {
            frm.before(res.data.msg);
            let parent = frm.parent();
            frm.remove();

            setTimeout(() => {
                parent.remove();
            }, 3000);
        }).done(() => {
            btn.prop('disabled', false).append('sd');
        });
    }

    remove_form(e) {
    	e && e.preventDefault();
		this.chat.$el.find('.wschat_email_transcript_form_popup').remove();
    }

	show_picker() {
		const file_input = jQuery(CONFIRM_EMAIL_TEMPLATE);

		this.remove_form();
		this.chat.$el.find('.chat-panel').after(file_input);
	}

}

EmailTranscriptPlugin.prototype.ACTION_EMAIL_TRANSCRIPT = 'wschat_email_transcript';

export const BTN_TEMPLATE = `
	<button id="wschat_email_transcript_picker" class="btn btn-sm attachment-list-item" title="Email Transcript">
		<i class="material-icons align-bottom">email</i>
	</button>
`;

export const CONFIRM_EMAIL_TEMPLATE = `
    <div class="wschat_email_transcript_form_popup p-3 pb-0">
    	<div class="row ">
              <label for="email_transcript_field_email" class="form-label col form-label-sm">Email</label>
              <button class="btn btn-sm col-auto" id="wschat_email_transcript_form_close" type="button"><i class="material-icons align-bottom">close</i></button>
    	</div>
        <form id="wschat_email_transcript_form" class="row">
            <div class="col">
              <input type="email" class="form-control form-control-sm" id="email_transcript_field_email" placeholder="name@example.com">
            </div>
            <div class="col-auto align-self-end g-0">
                <div class="">
                    <button class="btn btn-sm " type="submit"><i class="material-icons align-bottom">send</i></button>
                </div>
            </div>
        </form>
    </div>
`;

